{
  "name": "@gongfu/workflow-cli",
  "version": "0.4.2",
  "description": "AI-powered workflow management CLI for developers",
  "keywords": [
    "workflow",
    "cli",
    "ai",
    "development",
    "automation",
    "gongfu"
  ],
  "author": "Gongfu Team",
  "license": "MIT",
  "publishConfig": {
    "access": "public"
  },
  "bin": {
    "workflow": "dist/cli.js",
    "wf": "dist/cli.js"
  },
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "files": [
    "dist",
    "templates",
    "src/api/graphql/schema.graphql",
    "README.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup && pnpm postbuild",
    "postbuild": "mkdir -p dist/api/graphql && cp src/api/graphql/schema.graphql dist/api/graphql/",
    "clean": "rm -rf dist",
    "type-check": "tsc --noEmit",
    "lint": "eslint src --ext .ts",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "prepublishOnly": "pnpm build"
  },
  "dependencies": {
    "@apollo/server": "^4.9.5",
    "@gongfu/claude-integration": "^0.1.0",
    "@graphql-tools/schema": "^10.0.2",
    "chalk": "^5.3.0",
    "chokidar": "^4.0.0",
    "commander": "^14.0.0",
    "console-table-printer": "^2.12.1",
    "cors": "^2.8.5",
    "cosmiconfig": "^9.0.0",
    "crypto-js": "^4.2.0",
    "date-fns": "^3.0.0",
    "execa": "^9.6.0",
    "express": "^4.21.0",
    "fs-extra": "^11.3.0",
    "graphql": "^16.8.1",
    "graphql-subscriptions": "^2.0.0",
    "graphql-ws": "^5.14.3",
    "gray-matter": "^4.0.3",
    "handlebars": "^4.7.8",
    "inquirer": "^12.5.0",
    "js-yaml": "^4.1.0",
    "node-fetch": "^3.3.2",
    "open": "^10.1.0",
    "ora": "^8.2.0",
    "picocolors": "^1.1.0",
    "prompts": "^2.4.2",
    "slugify": "^1.6.6",
    "uuid": "^11.0.4",
    "winston": "^3.11.0",
    "winston-daily-rotate-file": "^4.7.1",
    "ws": "^8.16.0",
    "zod": "^3.24.1"
  },
  "devDependencies": {
    "@types/cors": "^2.8.17",
    "@types/crypto-js": "^4.2.2",
    "@types/express": "^5.0.0",
    "@types/fs-extra": "^11.0.4",
    "@types/handlebars": "^4.1.0",
    "@types/inquirer": "^9.0.8",
    "@types/js-yaml": "^4.0.9",
    "@types/node": "^24.0.0",
    "@types/open": "^6.2.1",
    "@types/prompts": "^2.4.9",
    "@types/supertest": "^6.0.2",
    "@types/uuid": "^10.0.0",
    "@vitest/coverage-v8": "^3.2.0",
    "supertest": "^7.0.0",
    "tsup": "^8.0.1",
    "typescript": "^5.8.3",
    "vitest": "^3.2.0"
  },
  "engines": {
    "node": ">=20.0.0"
  }
}
